@if (!packages?.isEmpty) {
  <div class="planning-draft-job-package-delta">
    <div class="diff-section-title br-caption-2" translate>Packages</div>

    @if (packages.added?.length) {
      <div class="tr diff-row">
        <div class="td"><span class="br-body-1 tr-label added-label" translate>Added</span></div>
        <div class="td tr-value--wide">
          @for (pkg of packages.added; track pkg.id) {
            <app-bringoz-package-item [id]="pkg.size" [count]="pkg.count">

            </app-bringoz-package-item>
          }
        </div>
      </div>
    }

    @if (packages.updated?.length) {
      <div class="tr diff-row">
        <div class="td"><span class="br-body-1 tr-label" translate>Updated</span></div>
      </div>
      @for (updated of packages.updated; track updated.id) {
        <app-pending-field-row [field]="packagesField" [pendingField]="updated"></app-pending-field-row>
      }
    }

    @if (packages.removed?.length) {
      <div class="tr diff-row">
        <div class="td"><span class="br-body-1 tr-label removed-label" translate>Removed</span></div>
        <div class="td tr-value--wide">
          @for (packageId of packages.removed; track packageId) {
            <div class="text-ellipsis">{{ packageId }}</div>
          }
        </div>
      </div>
    }
  </div>
}
